declare global {
  interface Window {
    umami?: {
      track: (eventName: string, data?: Record<string, unknown>) => void;
      identify: (data: Record<string, unknown>) => void;
    };
  }
}

function withRetry(
  fn: () => boolean,
  { maxTries = 5, delayMs = 200 } = {}
) {
  let tries = 0;
  const run = () => {
    if (fn()) return;
    if (tries++ < maxTries) {
      setTimeout(run, delayMs);
    }
  };
  run();
}

export function trackEvent(eventName: string, data?: Record<string, unknown>): void {
  if (!globalThis.window?.umami) return;
  globalThis.window.umami.track(eventName, {
    ...data,
    page: globalThis.window.location.pathname,
  });
}

export function identifyUser(data: Record<string, unknown>): void {
  if (globalThis.window === undefined) return;
  withRetry(() => {
    if (!globalThis.window?.umami) return false;
    globalThis.window.umami.identify(data);
    return true;
  });
}
